import { User } from "../context/users";

export const mockUser: User = {
    id: "shrawan.sah@salesforce.com",
    email: "shrawan.sah@salesforce.com",
    user_id: "shrawan.sah@salesforce.com",
    allowed_account_creation: "true",
    allowed_jit_admin_access: "true",
    allowed_drift_view: "true",
    allowed_scp_drift_view: "true", // NEW - Enable for testing
    roles: [
        "offline_access",
        "uma_authorization",
        "default-roles-pcsk"
    ],
    cloudZones: [
        "ou=falcondev,o=clouds,dc=falcondev,dc=sfdc,dc=net"
    ]
};

export const createMockJWT = (user: User): string => {
    const header = btoa(JSON.stringify({ alg: "HS256", typ: "JWT" }));
    const payload = btoa(JSON.stringify({
        email: user.email,
        exp: Math.floor(Date.now() / 1000) + (24 * 60 * 60), // 24 hours from now
        sub: user.user_id,
        iat: Math.floor(Date.now() / 1000),
        iss: "mock-pcsk"
    }));
    const signature = btoa("mock-signature");

    return `${header}.${payload}.${signature}`;
};
